import { useRef, useState } from "react";
import analyticsContext from "./analyticsContext";

const AnalyticsState = (props) => {
  const ref = useRef(null);
  const [widgetModeOpen, setWidgetModeOpen] = useState(false);
  return (
    <analyticsContext.Provider
      value={{
        widgetModeOpen, setWidgetModeOpen
      }}
    >
      {props.children}
    </analyticsContext.Provider>
  );
};

export default AnalyticsState;
